import React, { useState } from 'react';
import {
  Box,
  Menu,
  MenuItem,
  Checkbox,
  ListItemText,
  IconButton,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const options = [
  'Submitted',
  'Active',
  'Inactive',
  'Rejected',
  'Draft'
];

const StatusDropdown = (props) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleToggleOption = (option) => {
    const newSelectedOptions = selectedOptions.includes(option)
      ? selectedOptions.filter((item) => item !== option)
      : [...selectedOptions, option];

    setSelectedOptions(newSelectedOptions);
    props.handleStatusChange(newSelectedOptions);
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
      <Box
        role="button"
        tabIndex={0}
        onClick={handleOpen}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleOpen(event);
          }
        }}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          fontFamily: 'Lato',
          fontWeight: 800,
          fontSize: '16px',
          lineHeight: '19.2px',
          color: '#000',
          cursor: 'pointer',
          userSelect: 'none',
        }}
      >
        Status
        <IconButton
          size="small"
          sx={{ ml: 0.25, p: 0 }}
          aria-label="Open status filter"
        >
          <KeyboardArrowDownIcon fontSize="small" />
        </IconButton>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            onClick={() => handleToggleOption(option)}
            sx={{ padding: '4px 8px', width: '180px' }}
          >
            <Checkbox checked={selectedOptions.includes(option)} />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default StatusDropdown;
